import { requester } from "App";
import { textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { validateInputs } from "shared/utils/Utils";
import styles from "./VendingRegister.module.css";

function VendingRegister() {
    const inputs = useRef([]);
    const searchRef = useRef();
    const { t } = useTranslation();
    const [duplicateCheck, setDuplicateCheck] = useState(true);
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);
    const { userId, userName } = useContext(AuthContext);
    const [searchResults, setSearchResults] = useState();
    const [selectedVendorId, setSelectedVendorId] = useState();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        let data = { storeId: 'root' };
        requester.findAllVendor(data, (result) => {
            // 여기서 결과 처리
        });
    }, [isMounted]);

    const onClick = () => {
        let data = { vendorId: selectedVendorId, vendingName: '' };

        if (selectedVendorId) {
            validateInputs(inputs.current).then((result) => {
                if (result.isValid) {
                    data.vendingName = inputs.current[0].getValue();
                    requester.createVending(data, (result) => {
                        if (result.success) {
                            toast.success(t("registerSuccess"), {
                                autoClose: 1000,
                                position: toast.POSITION.BOTTOM_CENTER
                            });
                        } else {
                            toast.error(t("registerFailed"), {
                                autoClose: 1000,
                                position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                    });
                } else {
                    toast.error(t("pleaseCheck"), {
                        autoClose: 1000, 
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            });
        } else {
            toast.error(t("pleaseCheckVendor"), {
                autoClose: 1000, 
                position: toast.POSITION.BOTTOM_CENTER
            });
        }
    };

    const search = () => {
        let data = { userName: searchRef.current.getValue() };
        requester.searchVendor(data, (result) => {
            setSearchResults(result.data);
        });
    };

    const handleSelectChange = (e) => {
        setSelectedVendorId(e.target.value); // 선택된 값으로 상태 업데이트
    };

    return (
        <Container>
            <div className={styles.container}>
                <div className={styles.contentWrapper}>
                    <div className={styles.card}>
                        <div className={styles.header}>
                            <h1 className={styles.title}>자판기 등록</h1>
                        </div>
                        
                        <div className={styles.formSection}>
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>자판기 이름</P>
                                </div>
                                <div className={styles.formInput}>
                                    <InputText 
                                        ref={el => (inputs.current[0] = el)} 
                                        regExp={[textFormat]} 
                                    />
                                </div>
                            </div>
                            
                            <div className={styles.formRow}>
                                <div className={styles.formLabel}>
                                    <P>점주찾기 : </P>
                                </div>
                                <div className={styles.formInput}>
                                    <div className={styles.searchContainer}>
                                        <div className={styles.searchInput}>
                                            <InputText 
                                                ref={searchRef} 
                                                placeHolder={"점주 ID 검색"} 
                                            />
                                        </div>
                                        <CustomButton 
                                            text={"검색"} 
                                            onClick={search} 
                                            className={styles.searchButton}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            {searchResults && searchResults.length > 0 && (
                                <div className={styles.formRow}>
                                    <div className={styles.formLabel}></div>
                                    <div className={styles.formInput}>
                                        <select 
                                            onChange={handleSelectChange} 
                                            value={selectedVendorId}
                                            className={styles.vendorSelect}
                                        >
                                            <option value={""}>선택하세요</option>
                                            {searchResults.map((vendor, index) => (
                                                <option key={index} value={vendor.id}>
                                                    {vendor.userName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            <div className={styles.buttonContainer}>
                                <CustomButton 
                                    text={"기기등록"} 
                                    onClick={onClick} 
                                    className={styles.registerButton}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default VendingRegister;